import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAttachmentSource } from './iattachment-source';

@Injectable({ providedIn: 'root' })
export class InveniasAttachmentSource implements IAttachmentSource {
  getDefault(): string {
    throw new Error('Method not implemented.');
  }

  getOptions(): Observable<string[]> {
    throw new Error('Method not implemented.');
  }
}
